// Core
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Global Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Homepage from "./pages/Homepage";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import Sitemap from "./pages/Sitemap";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ThankYou from "./pages/ThankYou";
import BrochurePage from "./pages/BrochurePage";

const App = () => {
  return (
    <Router>
      {/* Global Header */}
      <Header />

      {/* Page Routing */}
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route exact path="/about-us" component={AboutUs} />
        <Route exact path="/services" component={Services} />
        <Route exact path="/gallery" component={Gallery} />
        <Route exact path="/contact-us" component={ContactUs} />
        <Route exact path="/sitemap" component={Sitemap} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/thank-you" component={ThankYou} />
        <Route exact path="/brochure" component={BrochurePage} />
      </Switch>

      {/* Global Footer */}
      <Footer />
    </Router>
  );
};

export default App;
